<template>
  <div class=" is-fullwidth">
    <div class="is-pulled-right"></div>
    <div class="is-pulled-right"><input class="input" v-model="search" placeholder="search orders ..."/></div>
    <div class="buttons">
      
        <button class="button " v-bind:class="{'is-success': selected_location_id == row.id}" v-for="row in locations" :key="row.id" @click="selected_location_id = row.id">{{ row.name }}</button>
      
        <button class="button is-light">{{ filteredOrders.length }} orders</button>
        <button class="button is-light">{{ this.total_garments }} garments</button>
    </div>

    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable">
    	<thead>
    		
        <th>PO Number</th>
   	 		<th>Customer</th>
          
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Garment</th>
          <th>Extras</th>
          <th>Qty</th>
          <th>Paper</th>
          <th>Rolls</th>
          <th>Cutting</th>
          <th>Cut Loc.</th>
          <th>Makeup Location</th>
          <th>&nbsp;</th>
    	</thead>
    	<tbody>
		    <tr v-if="loading === true">
                <td colspan="11" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && orders.length == 0">
                <td colspan="11" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
            
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
         
               <td >{{order.ponumber}}
                <router-link :to="'/printing-cutting/bundling/' + order.orderID" v-if="order.print_location_id != 2">
                <span class="icon" :class="{ 'has-text-success': order.bundles_created == 1, 'has-text-danger': order.bundles_created == 0}">
                 <i class="fa fa-barcode">&nbsp;</i>
               </span>
               </router-link>
              </td>
          <td>{{order.clientname}}</td>
           
          <td>{{order.deliverydate}}</td>
          <td>{{order.garmentname}}</td>
          <td>
            <div class="tags">
              <button class=" button tag  is-small" v-if="order.requires_embroidery==1" :class="{'is-success' : order.embroidery_complete == 1}" :disabled="working==true">Embroidery</button>
              <button class=" button tag   is-small" v-if="order.requires_embossing==1" :disabled="working==true">Embossing</button>
              <button class=" button tag  is-small" v-if="order.requires_silicon_stripes==1" :class="{'is-success' : order.silicon_complete == 1}" :disabled="working==true">Silicon </button>
              <button class=" button tag  is-small" v-if="order.requires_dtf==1" :disabled="working==true">DTF</button>
              <button class=" button tag  is-small" v-if="order.requires_gps_pockets==1" :disabled="working==true">GPS</button>
                <!-- changes to yellow when complete through the knitted trim section and green when completed here -->
              <button class=" button tag is-small" v-if="order.requires_knitted_trim==1" :class="{'is-warning': order.knit_complete == 1 && order.knitted_trim_complete == 0, 'is-success' : order.knitted_trim_complete == 1}" :disabled="working==true" @click="completeKnittedTrims(order)">Knitted Trim</button>
              
            </div>
          </td>
          <td>{{ order.total_qty }}</td>
          <td>
              <span class="icon has-text-success" v-if="order.artwork_printed_paper == 1">
                <i class="fa fa-check"></i>
            </span>
          </td>
          <td>
            <span class="icon has-text-success" v-if="order.artwork_printed_rolls == 1">
                <i class="fa fa-check"></i>
            </span>

          </td>
          <td>
<span class="icon has-text-success" v-if="order.digital_print_cutting == 1 || order.multiply_cutting == 1">
                <i class="fa fa-check"></i>
            </span>

          </td>
          <td>
            <span v-if="order.part_printed == 1 || order.cut_sew == 1">{{ order.cutting_location_name}}</span>
            <span v-else>N/A</span>
          </td>
          <td>
              <div class="buttons has-addons " :title="order.makeup_location_id">
                <select class="select is-small" v-model="order.makeup_location_id">
                  <option value="">Makeup Location</option>
                  <option :value="row.id" v-for="row in filteredLocations(order.makeup_location_id)" :key="row.id">{{ row.name }}</option>
                </select>
                <div v-if="false">
                <button class="button is-small " :class="{'is-success' : order.makeup_location_id==row.id}"  v-for="row in makeuplocations" :key="row.id" @click="order.makeup_location_id = row.id">{{ row.name }}</button>
                </div>
              </div>
          </td>
          <td>
              <button class="button is-success is-small" v-if="order.makeup_location_id > 0" @click="processOrder(order)" :disabled="working==true">Process</button>
          </td>
             
			</tr>
    	</tbody>
    </table>
    
    
    
  </div>
</template>


<script>


import OrderService from '@/services/OrderService.js';
import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      multiply_orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      makeuplocations: [],
      locations: [],
      selected_location_id: 0,
      order_by: 'deliverydate ASC',
      search: '',
      limit: ''
    }
  },
   methods: {
      async getOrders() {
        this.loading=true
        OrderService.getAwaitingMakeupOrders(this.accessToken, this.selected_location_id, this.limit, this.order_by)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
     filteredLocations(makeupLocationId) {
      return this.makeuplocations.filter(
        (loc) => loc.offshore_factory === 0 || loc.id === makeupLocationId
      );
    },

    
    async processOrder(order) {
        this.working = true

        var order_id = order.orderID

        var formdata = { 
            _method: 'patch',
             ready_for_makeup : 1,
             makeup_location_id : order.makeup_location_id
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            order.ready_for_makeup = 1
            this.working = false
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },

    async completeKnittedTrims(order) {
      this.working = true

      if(order.knitted_trim_complete == 1)
      {
          this.working = false
          return false
      }
      else
      {
        if(confirm("Are you sure you want to mark this order as Knitted Trims complete ?"))
        {
          var order_id = order.orderID

            var formdata = { 
                _method: 'patch',
                knitted_trim_complete : 1
                
            }; 

            OrderService.updateOrder(this.accessToken, order_id, formdata)
            .then(() => {
                order.knitted_trim_complete = 1
                this.working = false
                //console.log(response)
            }).catch((error) => {
              alert("Something went wrong and the order has not been updated. Please reload and try again")
                console.log("Error:" + JSON.stringify(error.response.data));
                this.working = false
            });
        }
        else{
          this.working = false
          return false
        }
        
      }
    },
    
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(u) {
            if(  u.ready_for_makeup == 0) 
            {
               console.log(u)
              return 1
            }
          })

          if(this.search != '' && this.search != null)
          {
            filteredOrders = filteredOrders.filter(row => row.ponumber.toLowerCase().includes(this.search.toLowerCase()))
          }

          return filteredOrders
       
     },
     total_garments: function () {
        return this.filteredOrders.reduce((total, order) => total + order.total_qty, 0);
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getLocations(1);
           this.getMakeupLocations(1);
        });
  },
 
  mounted() {
    /*if (localStorage.printing_limit) {
      this.limit = localStorage.printing_limit;
    }
    else{
      this.limit = ''
    }*/

    if (localStorage.printing_location_id) {
      this.selected_location_id = localStorage.printing_location_id;
    }
    else{
      this.selected_location_id = 1
    }
      
  },
   watch: {
    'selected_location_id'() {
      this.orders = []
      localStorage.printing_location_id = this.selected_location_id
      this.getOrders();
    },
    'limit'() {
      localStorage.printing_limit = this.limit
      this.orders = []
      this.getOrders();
    }
  }
}


</script>

<style scoped>
  td .tags span {text-decoration: none;}

</style>
